<template>
    <div class='body-main'>
        <div class="order-main clearfix">
            <div class="slider">
                <h1>个人设置</h1>
            </div>
            <el-tabs :tab-position="'left'" style="min-height: 500px;margin-top: 30px;">
                <el-tab-pane label="修改密码">
                    <el-tabs type="border-card" style="min-height: 500px;">

                    </el-tabs>
                </el-tab-pane>

            </el-tabs>
        </div>

        <!--登入-->
        <login v-bind:loginShow="loginShow" v-bind:activeName="activeName" @close="closeloginModal"/>
    </div>
</template>

<script>

    import Login from "./login";

    export default {
        name: "user",
        components: {
            Login,
        },
        data() {
            return {
                activeName: "login",
                loginShow: false,
            }
        },
        methods: {
            //关闭登入modal
            closeloginModal() {
                this.loginShow = false;
            },
        },
    }
</script>

<style>
    .body-main {
        min-height: 750px;
    }

    .order-main {
        width: 1152px;
        margin: 36px auto;
    }

    .slider h1 {
        padding-bottom: 16px;
        font-size: 18px;
        color: #4d555d;
        line-height: 32px;
        border-bottom: 1px solid #d9dde1;
    }

    .el-tabs__item {
        width: auto !important;
    }
</style>